import { CfCustomComponentProps } from "./types";
import CfCardOffer from "components/Cards/CardOfferNew/CfCardOffer";
import Loader from "components/Loader";
import React, { Suspense } from "react";

const Table01 = React.lazy(() => import("components/TableCF/Table01"));
const Table02 = React.lazy(() => import("components/TableCF/Table02"));

const CustomComponent = (props: CfCustomComponentProps) => {
  const { slug, configuration } = props;
  const dataJson =
    configuration !== null ? JSON.parse(configuration?.internal?.content) : {};

  return (
    <Suspense fallback={<Loader loading />}>
      {(() => {
        switch (slug) {
          case "table01":
            return <Table01 dataJson={dataJson} />;
          case "table02":
            return <Table02 dataJson={dataJson} />;
          case "card-offer":
            return (
              <CfCardOffer
                dataJson={dataJson}
                identifiers={{
                  contentful_id: props.contentful_id,
                  __typename: props.__typename,
                }}
              />
            );
          default:
            return null;
        }
      })()}
    </Suspense>
  );
};

export default CustomComponent;
